// extracted by mini-css-extract-plugin
export default {"agreement":"PwTe8UC3"};